module.exports = __webpack_public_path__ + "img/motorcheck-rotate.e0058f39.svg";